import { Textarea, type TextareaProps } from "@mantine/core"

type TProps = Omit<TextareaProps, "onChange"> & {
  onChange: (value: string) => void
}

export function AppTextarea({ onChange, ...props }: TProps) {
  return (
    <Textarea
      autosize
      minRows={3}
      maxRows={5}
      resize="vertical"
      {...props}
      onChange={(e) => onChange?.(e.currentTarget.value)}
    />
  )
}
